module.exports = __webpack_public_path__ + "img/Jd.3c1ac736.png";